import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Link, useLoaderData } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProductInformationCategories from 'src/components/product/ProductInformation/ProductInformationCategories';
import ProductInformationInfo from 'src/components/product/ProductInformation/ProductInformationInfo';
import ProductInformationAttributes from 'src/components/product/ProductInformation/ProductInformationAttributes';
import { CButton } from '@coreui/react';
import ProductInformationConfiguration from 'src/components/product/ProductInformation/ProductInformationConfiguration';

const urlApi_1 = '/products';
const urlRouter = '/products';
const cabinetLink = process.env.REACT_APP_SITE_URL;

export async function LoaderProductInformation({ params }) {
    if (Object.keys(params).length != 0) {
        let res = await AxiosInstance.get(`${urlApi_1}/${params.pid}`, {
            params: {
                "g[0]": "product:read",
                "g[1]": "product:admin",
                "g[2]": "product:productInfos",
                "g[3]": "product:attributeItems",
                "g[4]": "product:category",
                "g[5]": "product:media",
                "g[6]": "product:hover",
            }
        }).then((response) => {
            // console.log("get /api/products/ response", response);
            return response;
        });
        return res;
    }
    return false;
}

// Інформація про товар (тільки для перегляду)
const ProductInformation = () => {

    // const { data } = useLoaderData();
    const loaderResult = useLoaderData();
    const data = loaderResult?.data;

    const [userRole, setUserRole] = useState(false);

    // Взяти роль авторизованого користувача
    useEffect(() => {
        let role = localStorage.getItem('user_role');
        if (role === "ROLE_ADMIN") {
            setUserRole(role);
        };
    }, []);

    // Зображення для продукта
    const media = data?.media ?? [];
    const mainMedia = data?.mainMedia ?? null;

    // Індекс головного зображення з масиву media
    const indexMainMedia = useMemo(() => {
        if (!media.length || !mainMedia?.id) return 0;
        const idx = media.findIndex((m) => m.id === mainMedia.id);
        return idx >= 0 ? idx : 0;
    }, [media, mainMedia]);

    // Зображення-hover
    const mainMediaHover = data?.mainMediaHover ?? null;
    // const hoverSrc =
    //     mainMediaHover?.resizeImagings?.[1]?.contentUrl
    //         ?
    //         // process.env.REACT_APP_SERVER_URL + mainMediaHover.resizeImagings[1].contentUrl
    //         (mainMediaHover.resizeImagings?.[1]?.contentUrl
    //             ? process.env.REACT_APP_SERVER_URL + mainMediaHover.resizeImagings[1].contentUrl
    //             : process.env.REACT_APP_SERVER_URL + mainMediaHover.contentUrl)
    //         : null;
    const hoverSrc = mainMediaHover
        ? (
            mainMediaHover.resizeImagings?.length
                ? process.env.REACT_APP_SERVER_URL + mainMediaHover.resizeImagings[1]?.contentUrl
                : process.env.REACT_APP_SERVER_URL + mainMediaHover.contentUrl
        )
        : null;

    // Зображення, імпортоване з старого сайту
    const hasOldImg = Boolean(data?.imgUrl?.trim());
    const colImgClass = hasOldImg ? "col-12 col-md-6 col-lg-4" : "col-12 col-md-6 col-lg-6";

    // Сформувати рядки таблиці
    const rows = useMemo(() => {
        if (!data) return [];

        const showYesNo = (v) => (v ? "Так" : "Ні");

        return [
            { label: 'Назва товару', value: data.name ?? '' },
            { label: 'Товар продається', value: showYesNo(Boolean(data.show)) },
            { label: 'Новинка', value: showYesNo(Boolean(data.isNew)) },
            { label: 'Хіт продаж', value: showYesNo(Boolean(data.top)) },
            { label: 'Акція', value: showYesNo(Boolean(data.isSalle)) },
            { label: 'Товар під замовлення', value: showYesNo(Boolean(data.productToOrder)) },
            { label: 'Знято з виробництва', value: showYesNo(Boolean(data.discontinued)) },
            { label: 'Елемент Складу', value: data.storageElement?.name ?? '-' },
            { label: 'Опис', value: data.description ?? '', isHtml: true },
            { label: 'code1c', value: data.code1c ?? '' },
            { label: 'Штрихкод', value: data.barcode ?? '' },
            { label: 'Статус', value: data.status ?? '' },
            { label: 'Попередня ціна', value: data.oldPrice ?? '-' },
            { label: 'Акційна ціна', value: data.sallePrice ?? '-' },
            { label: 'Звичайна ціна', value: data.normalPrice ?? '-' },
            { label: 'Ціна на сайті', value: data.price ?? '' },
            { label: 'Знижки', value: data.discounts ?? '' },
            { label: 'Артикул', value: data.article ?? '' },
            { label: 'nds', value: data.nds ?? '' },
            { label: 'packaging', value: data.packaging ?? '' },
            { label: 'Одиниці виміру', value: data.measurement_unit?.short_name ?? '' },
            { label: 'Мета title', value: data.seoTitle ?? '' },
            { label: 'Мета description', value: data.seoDescription ?? '' },
        ];
    }, [data]);

    if (!data) return null; // Або loader

    return (
        <div>
            <h1 className="mb-3">{data.name}</h1>

            {/* Дозволити редагувати товар тільки ROLE_ADMIN */}
            {
                (userRole === "ROLE_ADMIN") && (
                    <Link to={`${urlRouter}/update/${data.id}`} className="mb-3">
                        <CButton className="mb-3" color="secondary" title="Редагувати товар">
                            Редагувати
                        </CButton>
                    </Link>
                )
            }

            {/* Перейти на товар на сайті */}
            <Link to={`${cabinetLink}/product/${data.id}`} className="mb-3 ms-3" target='_blank' rel="noreferrer">
                <CButton className="mb-3" color="secondary" title="Перейти на товар на сайті">
                    Перейти на сайт
                </CButton>
            </Link>

            <hr />

            {/* Блок з зображеннями */}
            <div className='row mb-3 flex-wrap flex-row'>
                <div className={colImgClass}>
                    <h2>Зображення</h2>
                    {
                        media.length > 0
                            ? (
                                <div style={{ maxWidth: "400px" }}>
                                    <Carousel
                                        style={{ height: '200px', width: 'auto' }}
                                        showArrows={false}
                                        showThumbs={true}
                                        showStatus={false}
                                        thumbWidth={80}
                                        selectedItem={indexMainMedia}
                                    >
                                        {
                                            // Відобразити всі зображення до продукту
                                            media.map(el => {
                                                const imgSrc = el?.resizeImagings?.length
                                                    ? process.env.REACT_APP_SERVER_URL + el.resizeImagings[2]?.contentUrl
                                                    : process.env.REACT_APP_SERVER_URL + el.contentUrl;
                                                return (
                                                    <div key={el.id}>
                                                        <img
                                                            className="me-3"
                                                            //   src={(media != '') ? process.env.REACT_APP_SERVER_URL + '' + el.contentUrl : ''} />
                                                            // src={process.env.REACT_APP_SERVER_URL + el?.resizeImagings[2]?.contentUrl}
                                                            // src={process.env.REACT_APP_SERVER_URL + el?.contentUrl}
                                                            src={imgSrc}
                                                        />
                                                    </div>
                                                )
                                            })
                                        }
                                    </Carousel>
                                </div>
                            )
                            : (
                                <div className="">Немає зображень</div>
                            )
                    }
                </div>

                <div className={colImgClass}>
                    <h2>Зображення Hover</h2>
                    <div>
                        {hoverSrc ? (
                            <img
                                className="me-3"
                                src={hoverSrc}
                                alt={`${data?.name ?? 'product'} hover`}
                                style={{ height: 200 }}
                            />
                        ) : (
                            <div className="">Немає hover-зображення</div>
                        )}
                    </div>
                </div>

                {/* Блок - старе імпортоване зображення */}
                {
                    hasOldImg &&
                    <div className={colImgClass}>
                        <h2>Старе (імпортоване) зображення</h2>
                        <div>
                            <img
                                className="me-3"
                                src={`${process.env.REACT_APP_SERVER_URL}/${data.imgUrl}`}
                                alt={`${data?.name ?? 'product'} hover`}
                                // style={{ height: 200 }}
                                style={{ height: "300px" }}
                            />
                        </div>
                    </div>
                }
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th className='products-table__th1'>#</th>
                        <th className='products-table__th2'>Назва</th>
                        <th>Значення</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        rows.map((row, index) => {
                            return (
                                <tr key={row.label}>
                                    <td className="products-table__td1">{index + 1}</td>
                                    <td>{row.label}</td>
                                    <td>
                                        {
                                            row.isHtml
                                                ? <div dangerouslySetInnerHTML={{ __html: row.value }} />
                                                : row.value
                                        }
                                    </td>
                                </tr>

                            )
                        })
                    }
                </tbody>
            </Table>

            {/* Інформація про товар */}
            {/* <ProductInformationInfo productId={data.id} /> */}

            {/* Інформація про товар */}
            <ProductInformationConfiguration productId={data.id} />

            {/* Атрибути */}
            <ProductInformationAttributes attributeItems={data.attributeItems} />

            {/* Категорії */}
            <ProductInformationCategories productId={data.id} />
        </div>
    );
};

export default ProductInformation;